<template>
    <span v-if="error" class="block text-red-700">{{ error }}</span>
</template>

<script>
export default {
    name: "Error",
    props: {
        error: String,
    },
};
</script>
